import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'how-it-works';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { howItWorks: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
